<template>
  <div class="online-payment-section online-payment-section-borderless mx-ni px-i pb-0">
    <div id="mastercard-form" class="online-payment-form">
      <div class="online-payment-form-row">
        <div class="online-payment-form-row-start flex-grow-1">
          <label class="online-payment-form-row-start-label">Card Number</label>
          <input id="card-number" type="text" class="form-control custom-input" value="" readonly="readonly">
        </div>
      </div>
      <div class="online-payment-form-row">
        <div class="online-payment-form-row-start">
          <div class="online-payment-form-row-start-date">
            <div class="online-payment-form-row-start-date-field">
              <label class="online-payment-form-row-start-date-field-label">Month</label>
              <input id="date_expiry_month" type="tel" name="" value="" class="form-control custom-input" readonly="readonly">
            </div>
            <div class="online-payment-form-row-start-date-field">
              <label class="online-payment-form-row-start-date-field-label">Year</label>
              <input id="date_expiry_year" type="tel" name="" value="" class="form-control custom-input" readonly="readonly">
            </div>
          </div>
        </div>
        <div class="online-payment-form-row-end">
          <label class="online-payment-form-row-end-label">CCV</label>
          <input id="security-code" type="text" class="form-control custom-input custom-input-shortened" value="" readonly="readonly">
        </div>
      </div>
      <div class="online-payment-form-row online-payment-form-row-areeba-strip">
        <span class="online-payment-form-row-areeba-strip-image" />
      </div>
    </div>
    <button id="mpgsPayButton" class="btn btn-primary ihjoz-button ihjoz-button-big-size online-payment-section-pay mb-3" type="button" @click="mpgsPay()">
      <i class="demo-icon icon-lock" />
      <div class="lds-ring payment-spinner">
        <div />
        <div />
        <div />
        <div />
      </div>Pay
    </button>
    <form id="3ds-form"
        ref="ds_form"
        name="3dsRedirect"
        method="POST"
        accept-charset="UTF-8"
        style="display: none;">
      <input ref="pareq" type="hidden" name="PaReq">
      <input ref="termUrl" type="hidden" name="TermUrl">
      <input type="hidden" name="MD" value="">
      <input id="3ds" type="submit" class="button">
    </form>
    <div class="online-payment-section-notice px-i">
      <p>By submitting the order you acknowledge that you agree to the Terms & Conditions of Fawter and the Invoice.</p>
      <p>*Prices are VAT inclusive</p>
    </div>
  </div>
</template>

<script>
import { loadMPGSPayment, mpgsDisablePayButton, updateMPGSPaymentSession } from "./loadMPGSPayment";
import PaymentStore from "./PaymentStore";
import ComponentMixin from "@shared/Mixins/ComponentMixin";

export default {
  name: "MpgsPaymentForm",

  props: {
    invoiceId: { type: Number },
    paymentMethod: { type: Object }
  },

  data() {
    return {
      sessionId: null
    }
  },

  mixins: [ComponentMixin],

  mounted () {
    this.initializePaymentGatewaySession();
  },

  watch: {
    paymentMethod: function () { this.loadMPGSPaymentForm(null); },
    sessionId: function (newVal, oldVal) {
      this.loadMPGSPaymentForm(newVal);
    }
  },

  methods: {
    async initializePaymentGatewaySession () {
      if (!this.sessionId) {
        let response = await PaymentStore.initializeSession(this.invoiceId);
        this.sessionId = response.session_id;
      }
    },

    mpgsPay () {
      mpgsDisablePayButton();
      updateMPGSPaymentSession();
    },

    loadMPGSPaymentForm (sessionID) {
      var mpgsScript = document.getElementById("online-payment");
      let vueComponentObject = this;
      if (mpgsScript) {
        mpgsScript.parentNode.removeChild(mpgsScript);
      }
      $("iframe.gw-proxy-number").remove();
      $("iframe.gw-proxy-securityCode").remove();

      mpgsScript = document.createElement("script");
      mpgsScript.setAttribute("Access-Control-Allow-Origin", "*");
      mpgsScript.setAttribute("id", "online-payment");

      mpgsScript.setAttribute("src", this.paymentMethod.key);

      document.head.appendChild(mpgsScript);
      mpgsScript.addEventListener("load", function () {
        if (sessionID) {
          loadMPGSPayment(vueComponentObject, sessionID);
        }
      });
    },

    async submitMPGSPayment (data) {
      let response = await PaymentStore.processMPGSPayment(this.invoiceId, data, this.paymentMethod.id);
      if (response.success) {
        this.$refs.pareq.value = response.pareq;
        this.$refs.ds_form.action = response.acs_url;
        this.$refs.termUrl.value = `${Dashboard.fawterDomain}/api/v4/mpgs_payment/${this.invoiceId}/pay_checkout?session_reference=${response.session_reference}`;
        this.$refs.ds_form.submit();
        e.preventDefault();
      } else {
        this.handleResponseInplace(response);
      }
    },
  }
}
</script>
